
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
    name: 'ImagePopup',
})
export default class ImagePopup extends Vue {
    @Prop({ type: String }) public src!: string;
    @Prop({ type: String, default: '' }) public imageClass!: string;

    public value = false;
}
